const DEFAULT_PATH = '/dashboard';

const ALLOWED_PREFIXES = [
  '/dashboard',
  '/works',
  '/profile',
  '/data',
  '/revenue',
  '/messages',
  '/settings',
  '/membership',
  '/mini-broker',
  '/ai-broker',
];

/** 仅允许站内相对路径，防止开放重定向 */
export function sanitizeRedirectPath(path: string | null | undefined): string {
  if (!path || typeof path !== 'string') return DEFAULT_PATH;
  let decoded = path.trim();
  try {
    decoded = decodeURIComponent(decoded);
  } catch {
    return DEFAULT_PATH;
  }
  if (!decoded.startsWith('/') || decoded.startsWith('//')) return DEFAULT_PATH;
  const pathname = decoded.split('?')[0];
  const allowed = ALLOWED_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
  return allowed ? decoded : DEFAULT_PATH;
}

export function getPostAuthRedirect(searchParams?: URLSearchParams | null): string {
  if (typeof window === 'undefined') return DEFAULT_PATH;
  const params = searchParams ?? new URLSearchParams(window.location.search);
  return sanitizeRedirectPath(params.get('redirect'));
}

export function getInviteTokenFromSearch(searchParams?: URLSearchParams | null): string | null {
  if (typeof window === 'undefined') return null;
  const params = searchParams ?? new URLSearchParams(window.location.search);
  const token = params.get('invite')?.trim();
  return token || null;
}

export function buildAlbumViewPath(albumId: string): string {
  return `/works?album=${encodeURIComponent(albumId)}&mode=view`;
}

export function appendQueryParams(
  basePath: string,
  params: Record<string, string | undefined | null>
): string {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) q.set(key, value);
  });
  const query = q.toString();
  return query ? `${basePath}?${query}` : basePath;
}
